import { useTranslation } from "@shared/utils/internationalization";
import Box from "@ui-kit/layout/Box/Box.web";
import Button from "@ui-kit/form/Button/Button.web";
import Text from "@ui-kit/typography/Text/Text.web";
import Flex from "@shared/components/ui-kit/layout/Flex/Flex.web";
import React from "react";
import CreateAccountForm from "../CreateAccountForm/CreateAccountForm.web";
import type { CreateAccountSharedProps } from "./CreateAccount.props";

export type CreateAccountProps = CreateAccountSharedProps & {
  // Add any web specific props here.
};

export default function CreateAccount(props: CreateAccountProps): JSX.Element {
  const { onSuccess, onLoginClick } = props;
  const { t } = useTranslation("common");

  return (
    <Box w="100%">
      <Text textStyle="heading.5xl" fontWeight="bold">
        {t("Create account")}
      </Text>
      <Box h="element.2xl" />
      <Flex direction="row" alignItems="center">
        {t("Already have an account?")}
        <Button
          colorPalette="secondary"
          variant="link"
          px="2xs"
          onClick={onLoginClick}
          data-testid="log-in-form-link"
        >
          {t("Log in")}
        </Button>
      </Flex>
      <Box h="element.2xl" />
      <CreateAccountForm onSuccess={onSuccess} />
    </Box>
  );
}
